/**
 * 
 * Establecer las sub categorías.
 * 
 * @param Object state 
 * @param Array nextState 
 */
export function setProdSga2subCategories(state, nextState) {
    state.prodSga2subCategories = nextState;
}

/**
 * Establecer Clases de peligro del SGA 2 asociadas al producto.
 * 
 * @param Object state 
 * @param Object nextState 
 * @return void 
 */
export function setProductSga2HazardClasses(state, nextState) {
    state.productSga2HazardClasses = nextState;
}